import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './styles/text-field.scss';

export default class TextField extends React.Component {
  constructor(props) {
    super(props);

    this.inputRef = React.createRef();
    this.handleChange = this.handleChange.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  focus() {
    const el = this.inputRef.current;
    el.selectionStart = el.selectionEnd = el.value.length;
    el.focus();
  }

  handleChange(value) {
    this.props.handleChange && this.props.handleChange(value);
  }

  handleKeyPress(e) {
    if (e.keyCode === 13) {
      this.props.onEnterKeyDown && this.props.onEnterKeyDown();
    }
  }

  render() {
    const {
      className,
      style,
      inputStyle,
      hintText,
      hintStyle,
      errorText,
      searchText,
      fullWidth,
      underlineShow,
      autofocus,
      onChange,
      value,
      defaultValue,
      ...rest
    } = this.props;

    const styles = {
      textAlign: hintStyle && hintStyle.textAlign,
      ...inputStyle,
    };
    const valueProps =
      defaultValue === undefined
        ? { value: value == null ? '' : value }
        : { defaultValue };

    return (
      <div
        className={cx('ui-textfield', className, {
          'ui-textfield--full-width': fullWidth,
        })}
        style={style}
        onKeyDown={this.handleKeyPress}
      >
        <input
          {...rest}
          {...valueProps}
          ref={this.inputRef}
          autoFocus={rest.autoFocus || autofocus}
          className={cx('ui-textfield__input', {
            'ui-textfield__input--error': !!errorText,
            'ui-textfield__input--no-underline': underlineShow === false,
          })}
          style={styles}
          placeholder={searchText ? undefined : hintText}
          onChange={(event) => {
            this.handleChange(event.target.value);
            onChange && onChange(event);
          }}
        />
        {errorText ? (
          <div className="ui-textfield__error ui-error">{errorText}</div>
        ) : null}
      </div>
    );
  }
}

TextField.propTypes = {
  defaultValue: PropTypes.any,
  hintText: PropTypes.any,
  style: PropTypes.any,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.any,
  hintStyle: PropTypes.object,
  errorText: PropTypes.any,
  inputStyle: PropTypes.object,
  fullWidth: PropTypes.bool,
  underlineShow: PropTypes.bool,
  handleChange: PropTypes.func,
  onEnterKeyDown: PropTypes.func,
};
